export const criarConfigBuscaDocumentoEntrada = (idOrganizacao) => ({
  label: 'Documento de Entrada',
  placeholder: 'Nº Documento...',
  titulo: 'Buscar Documento de Entrada',
  endpointApi: 'DocumentosEntrada',
  idField: 'idDocumentoEntrada',
  displayField: 'numeroDocumento',
  descField: 'numeroDocumento',
  // O endpoint DocumentosEntradaController.GetAll espera o parâmetro 'termo' (não 'busca').
  camposFiltro: [
    { label: 'Nº Documento', model: 'termo', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idDocumentoEntrada', width: '10%' },
    { header: 'Nº Documento', dataField: 'numeroDocumento', width: '25%' },
    { header: 'Série', dataField: 'serieDocumento', width: '10%' },
    // Apelido do parceiro fornecedor (resolvido no backend via PurchaseOrder → ParceiroNegocioFornecedor).
    { header: 'Fornecedor', dataField: 'parceiroFornecedorApelido', width: '30%' },
    { header: 'Emissão', dataField: 'dataEmissao', width: '15%' }
  ],
  filtrosFixos: { idOrganizacao }
})
